import {QUERY_CACHE_KEYS,FIELD_TYPES, COUNTRY_CODES} from '@chekin/core';

type GetResidenceCityQueryKey = {
  url?: string;
  residenceCountry?: string;
};

const getResidenceCityQueryKey = ({residenceCountry, url}: GetResidenceCityQueryKey) => {
  const isSpain = residenceCountry === COUNTRY_CODES.spain;

  if (isSpain) {
    return url
      ? [url]
      : [QUERY_CACHE_KEYS.paginatedSpanishResidenceCities, residenceCountry];
  }

  return [QUERY_CACHE_KEYS.paginatedCitiesList, residenceCountry];
};

const getIsSelectFieldType = (fieldType: FIELD_TYPES) => {
  return fieldType === FIELD_TYPES.select;
};

export {getIsSelectFieldType, getResidenceCityQueryKey};
